import React from "react";
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  PopoverFooter,
  PopoverArrow,
  PopoverCloseButton,
  Button,
} from "@chakra-ui/react";

const ScratchathonThemePopover = ({ theme: { title, description } }) => {
  return (
    <Popover>
      <PopoverTrigger>
        <button className="shadow-lg bg-gray-800 hover:bg-gray-900 text-white hover:shadow-xl duration-150 px-8 py-3 font-bold rounded-md w-full md:w-auto">
          Theme: {title}
        </button>
      </PopoverTrigger>
      <PopoverContent>
        <PopoverArrow />
        <PopoverCloseButton />
        <PopoverBody>{description}</PopoverBody>
      </PopoverContent>
    </Popover>
  );
};

export default ScratchathonThemePopover;
